export function invertResult(promise: Promise<boolean>): Promise<boolean> {
    const origPromise = promise;

    return new Promise<boolean>((resolve, reject) => {
        origPromise
            .then(val => {
                resolve(!val);
            })
            .catch(error => {
                reject(error);
            });
    });
}

export default Object.freeze({
    invertResult,
});
